import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/documents')({
  staticData: { breadcrumb: 'Documents', breadcrumbKey: 'K_BREADCRUMB_DOCUMENTS' },
  component: DocumentsLayout,
});

function DocumentsLayout() {
  return <Outlet />;
}
